import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HeadersService } from '../headers/headers.service';

export interface GenerateOauthLinkRequest {
  crm_type: 'hubspot' | 'salesforce';
}

export interface GenerateOauthLinkResponse {
  authorization_url: string;
}

export interface GetCrmDataRequest {
  fields?: string[];
  filters: { group_account_id: number };
  limit?: number;
  offset?: number;
}

export interface CrmIntegrationResponse {
  uid: string;
  type: 'hubspot' | 'salesforce';
  status: 'active' | 'invalid_token' | 'permissions_error';
  scopes?: string;
  instance_url?: string;
}

export interface CreateCrmTaskRequest {
  title: string;
  description: string;
  due_date?: string; // ISO string
}

export interface CreateCrmTaskResponse {
  success: boolean;
  task_id?: string;
  task_url?: string;
}

@Injectable({ providedIn: 'root' })
export class ApiCrmService {
  constructor(private http: HttpClient, private headersService: HeadersService) {}

  generateOauthLink(body: GenerateOauthLinkRequest): Observable<string> {
    return this.http
      .put<GenerateOauthLinkResponse>(
        `${environment.explainApiUrl}crm/oauth/generate-link`,
        body,
        this.headersService.httpHeaders
      )
      .pipe(map((res) => res.authorization_url));
  }

  getCrmData(body: GetCrmDataRequest): Observable<CrmIntegrationResponse[]> {
    return this.http
      .post<{ data: CrmIntegrationResponse[] }>(
        `${environment.explainApiUrl}crm/crm-data`,
        body,
        this.headersService.httpHeaders
      )
      .pipe(map((res) => res?.data ?? []));
  }

  createCrmTask(body: CreateCrmTaskRequest): Observable<CreateCrmTaskResponse> {
    return this.http.put<CreateCrmTaskResponse>(
      `${environment.explainApiUrl}crm/crm-tasks`,
      body,
      this.headersService.httpHeaders
    );
  }
} 